// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.copy-right {\r\n  position: absolute;\r\n  bottom: 0;\r\n  font-size: 12px;\r\n  color: #aaa;\r\n  line-height: 16px;\r\n  padding:5px 10px;\r\n  width: 100%;\r\n  background-color: #304156;\n}\n.copy-right p {\r\n  margin: 0;\n}\n.el-scrollbar__view{\r\n  margin-bottom: 80px;\n}\r\n", ""]);
// Exports
module.exports = exports;
